import React, { useRef, useContext, useEffect } from "react"
import styled from "styled-components"
import ContentWrapper from "styles/contentWrapper"

const featuresLogo = "https://hrflow-ai.imgix.net/features.svg"
const checkIcon = "https://hrflow-ai.imgix.net/check.svg"
const cancelIcon = "https://hrflow-ai.imgix.net/cancel.svg"

const StyledSection = styled.section`
  width: 100%;
  height: auto;
  background: ${({ theme }) => theme.colors.white};
  padding: 3rem 0;
  padding-bottom: 6rem;
  .section-title {
    padding: 0 1rem;
    span {
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
`

const StyledContentWrapper = styled(ContentWrapper)`
  && {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-right: 0;
    padding-left: 0;
    @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
      padding-right: 2.5rem;
      padding-left: 2.5rem;
    }
  }

  .table {
    width: 100%;
    border: 1px solid #bddae3;
    box-sizing: border-box;
    border-top-right-radius: 1.5rem;
    border-top-left-radius: 1.5rem;
    border-radius: unset;
    .table__header {
      display: flex;
      justify-content: space-between;
      @media (max-width: 600px) {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .features {
          margin-bottom: 1rem;
        }
      }
      padding: 2rem;
      .features {
        display: flex;
        align-items: center;
        .logo {
          background-image: url(${featuresLogo});
          background-size: 3.3rem 3.74rem;
          background-repeat: no-repeat;
          height: 3.74rem;
          width: 3.3rem;
          margin-right: .85rem;
        }
        .text {
          line-height: 1.75rem;
          font-size: 1.5rem;
          font-weight: 600;
          letter-spacing: -.05rem;
          color: #00495d;
        }
      }
      .enterprise {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .button-plan {
          background: #00cee0;
          border-radius: .25rem;
          line-height: normal;
          font-size: .7rem;
          text-align: center;
          letter-spacing: .065rem;
          text-transform: uppercase;
          color: #fff;
          border-style: none;
          padding: .7rem 2.8rem .85rem 2.8rem;
          font-weight: 600;
          cursor: pointer;
          &:hover {
            opacity: 0.9;
          }
        }
      }
    }
    .table__body {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-orient: vertical;
      -webkit-box-direction: normal;
      -ms-flex-direction: column;
      flex-direction: column;
      max-width: 100%;
      .table__row {
        border-top: 1px solid #bddae3;
        .item {
          background-color: #f8feff;
          @media (max-width: 800px) {
            padding-left: 0.5rem;
            padding-right: 0.5rem;
          }
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-top: 1rem;
          padding-bottom: .95rem;
          padding-left: 2.55rem;
          padding-right: 1.55rem;
          .text {
            line-height: 1.85rem;
            font-size: 1rem;
            font-weight: 600;
            letter-spacing: -.05rem;
            color: #00495d;
          }
          .hrflow {
            opacity: 1;
          }
          .cel {
            width: 25.16%;
            line-height: 1.85rem;
            font-size: 1rem;
            letter-spacing: -.05rem;
            color: #00495d;
            padding-top: .95rem;
            padding-bottom: .9rem;
            opacity: 0.6;
            margin: 0 0.2rem;
            word-break: break-all;
            @media (max-width: 500px) {
              font-size: 0.5rem;
            }
            .imp {
              border-right: 1px solid #bddae3;
              opacity: 1;
              border-top: none;
              border-right: none!important;
            }
          }
        }
        .content {
          .content__row {
            border-top: 1px solid #bddae3;
            display: -webkit-box;
            display: -ms-flexbox;
            display: flex;
            padding-left: 2.55rem;
            padding-right: 1.55rem;
            @media (max-width: 800px) {
              padding-left: 0.5rem;
              padding-right: 0.5rem;
            }
            .cel {
              width: 25.16%;
              line-height: 1.85rem;
              font-size: 1rem;
              letter-spacing: -.05rem;
              color: #00495d;
              padding-top: .95rem;
              padding-bottom: .9rem;
              margin: 0 0.2rem;
              display: flex;
              flex-wrap: wrap;
              word-break: break-all;
              @media (max-width: 500px) {
                font-size: 0.5rem;
              }
              .tag {
                border-radius: 0.25rem;
                background-color: #f0f4f8;
                padding-left: 0.5rem;
                padding-right: 0.5rem;
                padding-top: 0.25rem;
                padding-bottom: 0.25rem;
                margin: 0.2rem;
                max-height: 2.5rem;
              }
              .imp {
                background-color: #f8feff;
                border-right: 1px solid #bddae3;
                opacity: 1;
              }
              .times {
                background-image: url(${cancelIcon});
                background-position: center;
                background-size: 1.45rem 1.45rem;
                height: 1.45rem;
                width: 1.45rem;
                background-repeat: no-repeat;
              }
              .check {
                background-image: url(${checkIcon});
                background-position: center;
                background-size: 1.45rem 1.45rem;
                height: 1.45rem;
                width: 1.45rem;
                background-repeat: no-repeat;
              }
            }
          }
        }
      }
    }
  }
`


const DataPoints = () => {
  return (
    <StyledSection id="DataPoints">
      <StyledContentWrapper>
        <h2 className="section-title">
          HrFlow.ai vs. Elasticsearch vs. Solar
        </h2>
        <div className="table searching">
          <div className="table__body">
            <div className="table__row">
              <div className="item">
                <div className="category text cel">Searching</div>
                <div className="attribute text  cel">Solr</div>
                <div className="desc text cel">Elasticsearch</div>
                <div className="example text cel">HrFlow.ai</div>
              </div>
              <div className="content">
                <div className="content__row">
                  <div className="category cel">Cost unit</div>
                  <div className="attribute cel">Number of Requests</div>
                  <div className="desc cel">Number of Requests</div>
                  <div className="example cel">Number of Records</div>
                </div>
                <div className="content__row">
                  <div className="category cel">Cost effectiveness</div>
                  <div className="attribute cel">Very Expensive</div>
                  <div className="desc cel">Expensive</div>
                  <div className="example cel">Effective & Predictable</div>
                </div>
                <div className="content__row">
                  <div className="category cel">Tokenisation</div>
                  <div className="attribute cel">Very hard</div>
                  <div className="desc cel">Hard</div>
                  <div className="example cel">Auto-managed</div>
                </div>
                <div className="content__row">
                  <div className="category cel">Auto-scaling</div>
                  <div className="attribute cel">Semi-managed</div>
                  <div className="desc cel">Auto-managed</div>
                  <div className="example cel">Abstracted</div>
                </div>
                <div className="content__row">
                    <div className="category cel">Data indexing</div>
                    <div className="attribute cel">Self-managed</div>
                    <div className="desc cel">Self-managed</div>
                    <div className="example cel">
                      Auto-managed
                    </div>
                </div>
                <div className="content__row">
                    <div className="category cel">HR data format</div>
                    <div className="cel"><div className="times"></div></div>
                    <div className="cel"><div className="times"></div></div>
                    <div className="cel"><div className="check"></div></div>
                </div>
                <div className="content__row">
                    <div className="category cel">HR language understanding</div>
                    <div className="cel"><div className="times"></div></div>
                    <div className="cel"><div className="times"></div></div>
                    <div className="cel"><div className="check"></div></div>
                </div>
                <div className="content__row">
                    <div className="category cel">Synonyms</div>
                    <div className="cel"><div className="times"></div></div>
                    <div className="cel"><div className="times"></div></div>
                    <div className="cel"><div className="check"></div></div>
                </div>
                <div className="content__row">
                  <div className="category cel">Typo correction</div>
                  <div className="cel"><div className="times"></div></div>
                  <div className="cel"><div className="times"></div></div>
                  <div className="cel"><div className="check"></div></div>
                </div>
                <div className="content__row">
                  <div className="category cel">Language detection</div>
                  <div className="cel"><div className="times"></div></div>
                  <div className="cel"><div className="times"></div></div>
                  <div className="cel"><div className="check"></div></div>
                </div>
                <div className="content__row">
                  <div className="category cel">Multilingual</div>
                  <div className="cel"><div className="times"></div></div>
                  <div className="cel"><div className="times"></div></div>
                  <div className="cel"><div className="check"></div></div>
                </div>
                <div className="content__row">
                  <div className="category cel">Zero-config</div>
                  <div className="cel"><div className="times"></div></div>
                  <div className="cel"><div className="times"></div></div>
                  <div className="cel"><div className="check"></div></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </StyledContentWrapper>
    </StyledSection>
  )
}


export default DataPoints